import * as styles from "./IntroSponsorDogProfile.module.scss";

import React from "react";
import HeroImage from "../../../components/HeroImage/HeroImage";
import CurvedBorderShallow from "../../../components/borders/CurvedBorderShallow";
import type {
	MediaImageProps,
	MediaVideoProps,
} from "../../../components/common/MediaCarousel/MediaCarousel";
import { Colours } from "../../../utils/colours";
import IntroTripleCarousel from "../IntroTripleCarousel";

export interface IntroSponsorDogProfileProps {
	title: string;
	galleryItems: (MediaImageProps | MediaVideoProps)[];
	body: string;
	breed: string;
	centreName: string;
	sex: string;
	borderColour?: string;
}

const SponsorDogHeaderImage: React.FC<MediaImageProps> = ({ alt, src }) => (
	<HeroImage
		className={styles.headerimage}
		src={src}
		alt={alt}
		loading="eager"
	/>
);

export const IntroSponsorDogProfile: React.FC<IntroSponsorDogProfileProps> = ({
	title,
	body,
	breed,
	centreName,
	sex,
	galleryItems,
}) => {
	return (
		<div className={styles.sadprofilecontainer}>
			<IntroTripleCarousel media={galleryItems} isDog={false} />
			<div className={styles.dogdetails}>
				<div className={styles.title}>
					<h1>{title}</h1>
				</div>
				{!!body && (
					<div className={styles.subtitle}>
						<p>{body} </p>
					</div>
				)}
				<h2>{breed}</h2>
				<p>{centreName}</p>
				<p>{sex === "male" ? "Male" : "Female"}</p>
			</div>
			<div className={styles.bottombordersection}>
				<CurvedBorderShallow
					rotation={0}
					className={styles.bottomborder}
					fill={Colours.WHITE}
				/>
			</div>
		</div>
	);
};

export default IntroSponsorDogProfile;
